import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { FullTable, UploadModal } from 'components';
import {
  resourceFileNotYet,
  resourceFilesBody,
  resourceFilesHead,
} from './constants';
import { resourceActions } from 'store';
import { sortListByKey, useModal } from 'utils';


const DELETE_ACTION_TYPE = 'DELETE_RESOURCE_DOCUMENT';
const GET_DOCUMENT_ACTION_TYPE = 'GET_RESOURCE_DOCUMENT';

export const ResourceFilesComponent = ({ documents, height, noSearch, margin }) => {
  const resourceById = useSelector((state) => state.resource.resourceById);
  const dispatch = useDispatch();
  const { open } = useModal();
  const [selectedId, setSelectedId] = useState('');
  const params = useParams();
  const currentId = params?.id;
  const onResource = 'resource';

  const handleDelete = (item) => {
    dispatch(resourceActions.deleteResourceDocument(currentId, item?._id));
  };

  const handleDownload = (item) => {
    const fileType =
      item?.file?.originalName ? item?.file?.originalName :
        item?.file?.format === 'svg+xml' ? 'file.svg' : `file.${item?.file?.format}`;
    setSelectedId(item?._id || item?.id);
    axios({
      url: `/files/download`,
      method: 'POST',
      responseType: 'blob',
      data: item?.file,
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileType);
      document.body.appendChild(link);
      link.click();
      setSelectedId('');
    }).catch(() => {
      setSelectedId('');
    });
  };

  const handleClickActions = (item, name) => {
    if (name === 'delete') {
      handleDelete(item);
    } else if (name === 'download') {
      setSelectedId(item?._id || item?.id);
      handleDownload(item);
    } else if (name === 'edit') {
      open(
        <UploadModal
          defaultValue={item}
          currentId={currentId}
          onResource={onResource}
        />,
      );
    }
  };

  return (
    <div>
      <div className='dock-table-wrapper'>
        <FullTable
          head={resourceFilesHead(noSearch, resourceById?.adminAccess)}
          body={resourceFilesBody(selectedId, resourceById?.adminAccess, handleClickActions, DELETE_ACTION_TYPE)}
          loadingType={GET_DOCUMENT_ACTION_TYPE}
          list={documents?.length ? sortListByKey(documents, 'name') : []}
          handleClickButton={(name, item) => handleClickActions(name, item)}
          notYet={resourceFileNotYet}
          activeRowId={''}
          height={height}
          margin={margin ? margin : '0'}
          noText='Files Uploaded'
        />
      </div>
    </div>
  );
};